// Lightweight floating toast at the top of the screen. Auto-dismisses.
// Used for "Load saved" / "Load updated" / etc.

import { icon as svg } from './icons.js';

let activeToast = null;

export function toast(message, { tone = 'good', duration = 3500 } = {}) {
  // Replace any existing toast immediately
  if (activeToast) { activeToast.remove(); activeToast = null; }

  const bg = tone === 'good' ? 'bg-success text-white'
          : tone === 'bad'  ? 'bg-danger text-white'
          :                   'bg-header text-white';
  const mark = tone === 'good' ? svg.check('w-4 h-4') : tone === 'bad' ? svg.x('w-4 h-4') : svg.info('w-4 h-4');

  const el = document.createElement('div');
  el.className = `fixed left-1/2 -translate-x-1/2 z-[200]
                  ${bg} font-bold text-[15px] tracking-tight
                  px-5 py-3 rounded-full
                  flex items-center gap-2
                  animate-[toastIn_0.25s_cubic-bezier(0.34,1.56,0.64,1)]`;
  el.style.top = `calc(env(safe-area-inset-top, 0px) + 14px)`;
  el.innerHTML = `<span class="flex-none">${mark}</span><span>${escapeHtml(message)}</span>`;

  // Add inline keyframes the first time
  if (!document.getElementById('klt-toast-styles')) {
    const style = document.createElement('style');
    style.id = 'klt-toast-styles';
    style.textContent = `
      @keyframes toastIn {
        from { opacity: 0; transform: translate(-50%, -20px); }
        to   { opacity: 1; transform: translate(-50%, 0); }
      }
      @keyframes toastOut {
        from { opacity: 1; transform: translate(-50%, 0); }
        to   { opacity: 0; transform: translate(-50%, -20px); }
      }
    `;
    document.head.appendChild(style);
  }

  document.body.appendChild(el);
  activeToast = el;

  setTimeout(() => {
    if (el !== activeToast) return; // a newer toast replaced us
    el.style.animation = 'toastOut 0.2s ease-in forwards';
    setTimeout(() => { if (el.parentNode) el.remove(); if (activeToast === el) activeToast = null; }, 220);
  }, duration);
}

function escapeHtml(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
